var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "select-preview-component" },
    [
      _c("div", { staticClass: "m-b-10 text-right clear-fix" }, [
        _c("h6", { staticClass: "pull-left" }, [_vm._v("Preview")]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.preview_type,
                expression: "preview_type"
              }
            ],
            staticClass: "btn-browse btn-sm",
            attrs: { title: "Clear preview" },
            on: {
              click: function($event) {
                return _vm.clear_preview()
              }
            }
          },
          [_c("div", { staticClass: "fa fa-trash" })]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row m-b-20" }, [
        _c("div", { staticClass: "col-md-6" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.preview_type,
                expression: "preview_type"
              }
            ],
            staticClass: "radio-custom",
            staticStyle: { width: "140px" },
            attrs: { type: "radio", value: "generated" },
            domProps: { checked: _vm._q(_vm.preview_type, "generated") },
            on: {
              change: function($event) {
                _vm.preview_type = "generated"
              }
            }
          }),
          _vm._v(" "),
          _c("label", { staticClass: "radio-custom-label" }, [
            _vm._v("Auto-generated")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.preview_type,
                expression: "preview_type"
              }
            ],
            staticClass: "radio-custom",
            attrs: {
              type: "radio",
              value: "trailer",
              title: "upload your trailer"
            },
            domProps: { checked: _vm._q(_vm.preview_type, "trailer") },
            on: {
              change: function($event) {
                _vm.preview_type = "trailer"
              }
            }
          }),
          _vm._v(" "),
          _c("label", { staticClass: "radio-custom-label" }, [
            _vm._v("Trailer")
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.preview_type === "trailer" && _vm.trailer_status !== "COMPLETE"
        ? _c(
            "div",
            [
              _c("p", { staticClass: "small m-b-0" }, [
                _vm._v("Supported formats: MP4, WEBM, MOV, AVI, MKV, FLV")
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "small m-b-0" }, [
                _vm._v("Minimum duration = 10 seconds")
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "small" }, [
                _vm._v("Maximum File Size = 50MB.")
              ]),
              _vm._v(" "),
              _c("upload-video", { attrs: { kind: "trailer" } })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.preview_type === "generated"
        ? _c("div", [
            _c("div", { staticClass: "m-b-10" }, [
              _vm._v("Allow customers to preview your video before purchase")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row m-b-10" }, [
              _c("div", { staticClass: "col-md-6" }, [
                _c("label", { staticClass: "text-secondary" }, [
                  _vm._v(
                    "\n                    Start Time(s)\n                    "
                  ),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.generated_start_time,
                        expression: "generated_start_time"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      min: "0",
                      type: "number",
                      disabled: _vm.generated_status !== "INITIATED"
                    },
                    domProps: { value: _vm.generated_start_time },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.generated_start_time = $event.target.value
                      }
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }, [
                _c("label", { staticClass: "text-secondary" }, [
                  _vm._v(
                    "\n                    Length(s)\n                    "
                  ),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.generated_duration,
                        expression: "generated_duration"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      min: "0",
                      type: "number",
                      disabled: _vm.generated_status !== "INITIATED"
                    },
                    domProps: { value: _vm.generated_duration },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.generated_duration = $event.target.value
                      }
                    }
                  })
                ])
              ])
            ]),
            _vm._v(" "),
            _vm.generated_status !== "COMPLETE"
              ? _c(
                  "div",
                  {
                    staticClass: "btn-browse btn-sm",
                    class: { disabled: _vm.generated_status !== "INITIATED" },
                    attrs: {
                      title: _vm.generate_await_main_video
                        ? "Await uploading main video"
                        : "Generate preview"
                    },
                    on: {
                      click: function($event) {
                        return _vm.generate_preview()
                      }
                    }
                  },
                  [
                    ["INITIATED"].includes(_vm.generated_status)
                      ? _c("span", [_vm._v("Generate preview")])
                      : ["SUBMITTED", "PROGRESSING"].includes(
                          _vm.generated_status
                        )
                      ? _c("span", [
                          _vm._v("\n              Processing\n              "),
                          _vm.generated_job_percent_complete
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(_vm.generated_job_percent_complete) +
                                    "%"
                                )
                              ])
                            : _c("span", {
                                staticClass: "fa fa-spin fa-spinner"
                              })
                        ])
                      : ["COMPLETE"].includes(_vm.generated_status)
                      ? _c("span", [_vm._v("Complete")])
                      : _vm._e()
                  ]
                )
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.preview_status === "COMPLETE"
        ? _c("theo-player", { attrs: { kind: _vm.preview_type } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }